/*
  InStyle — the catalogue (snippets/instyle-catalogue.liquid), rounds 5 and 6b.

  Opens from anything marked data-instyle-catalogue-open. Those are real links
  to /collections, so a modified click (new tab) or a browser without <dialog>
  still goes there; only a plain click is taken over. Every opener carries
  aria-expanded, true while the catalogue it opened is showing.

  PHONE AND TABLET (below 990px): a full-screen sheet, as round 5 built it.
    - showModal(): the page behind is inert and Esc fires `cancel`.
    - Tab and Shift+Tab wrap inside the dialog, so focus never leaves it.
    - html.instyle-catalogue-open stops the page behind from scrolling.

  COMPUTER (990px and up), since 2026-10-03: the click opens the menu bar's
  own catalogue panel, pinned under the menu bar (snippets/instyle-mega-
  menu.liquid, window.InStyleMega.pin). Naman found the dropdown below
  "appearing in the middle of the page". The dropdown remains only as the
  fallback when the header has no such panel.

  COMPUTER FALLBACK: a DROPDOWN under the button's own row (round 6b).
    Naman, on the round-5 centred modal over a grey backdrop: "it shows like
    this in the middle of the screen which looks abrupt". Now:
    - show(), not showModal(): no backdrop, the page is not locked and does
      not go inert. It is the hover panel's own look (instyle-brand.css),
      spanning the page-content width directly under the row that holds the
      button (data-instyle-catalogue-row), or under the button itself.
    - Its height is capped at what is left of the screen below it; past
      that it scrolls inside, so it never runs off the screen.
    - The room you are in is emphasised, as the hover panel does it.
    - Esc, a click outside, the close button, or the button again close it.
      Tabbing out of it closes it too.

  BOTH: focus starts on the close button and returns to the button that
  opened it, except after a click elsewhere that put focus on a link or a
  field (the visitor's choice is never taken away).
  Closing plays the closing animation; the animation's end event is not the
  only way out, a timer closes it anyway (a backgrounded tab can drop the
  event). Reduced motion: no animation, and it closes at once.
*/
(function () {
  'use strict';

  var dlg = document.getElementById('InstyleCatalogue');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desk = window.matchMedia('(min-width: 990px)');
  var GAP = 8; // px between the row and the dropdown
  var MIN_H = 200; // the dropdown is never squeezed below this
  var EDGE = 8; // px kept clear between its bottom and the screen's
  var opener = null;
  var mode = null; // 'sheet' | 'drop' while open
  var restore = true;
  var closing = false;
  var closeTimer = null;
  var handled = 0; // `close` events already accounted for by finish()

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function focusables() {
    return Array.prototype.filter.call(
      dlg.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      visible
    );
  }

  function expand(el, on) {
    if (el && el.setAttribute) el.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  /* ---- computer: where the dropdown goes ---- */

  // The page-content box: the .page-width the row sits in, or failing that
  // the first one on the page, minus its side padding.
  function contentBox(from) {
    var pw = (from && from.closest('.page-width')) || document.querySelector('main .page-width');
    if (!pw) return { left: 0, width: html.clientWidth };
    var r = pw.getBoundingClientRect();
    var cs = getComputedStyle(pw);
    var pl = parseFloat(cs.paddingLeft) || 0;
    var pr = parseFloat(cs.paddingRight) || 0;
    return { left: r.left + pl, width: r.width - pl - pr };
  }

  function place() {
    if (mode !== 'drop' || !opener) return;
    var row = opener.closest('[data-instyle-catalogue-row]') || opener;
    var rr = row.getBoundingClientRect();
    var box = contentBox(row);
    // The dialog is absolutely positioned in its containing block (the
    // header section), so it is placed relative to that, in page
    // coordinates: it then stays attached to its row as the page scrolls.
    var cb = dlg.offsetParent || document.body;
    var cr = cb.getBoundingClientRect();
    var top = rr.bottom + GAP;
    var room = window.innerHeight - top - EDGE;
    if (room < MIN_H) {
      // So low on the screen that it would barely open: bring the row up.
      window.scrollBy(0, MIN_H - room);
      rr = row.getBoundingClientRect();
      cr = cb.getBoundingClientRect();
      top = rr.bottom + GAP;
      room = window.innerHeight - top - EDGE;
    }
    dlg.style.top = Math.round(top - cr.top) + 'px';
    dlg.style.left = Math.round(box.left - cr.left) + 'px';
    dlg.style.width = Math.round(box.width) + 'px';
    dlg.style.maxHeight = Math.max(MIN_H, Math.floor(room)) + 'px';
  }

  function unplace() {
    dlg.style.top = dlg.style.left = dlg.style.width = dlg.style.maxHeight = '';
  }

  // The room you are in: the group holding this page's link.
  function emphasise() {
    var inner = dlg.querySelector('.instyle-catalogue__desk');
    if (!inner) return;
    var groups = inner.querySelectorAll('.instyle-mega__group');
    var here = inner.querySelector('.instyle-mega__group [aria-current="page"]');
    var mine = here && here.closest('.instyle-mega__group');
    for (var i = 0; i < groups.length; i++) groups[i].classList.toggle('is-emph', groups[i] === mine);
    if (mine) inner.setAttribute('data-emph', mine.getAttribute('data-room') || '');
    else inner.removeAttribute('data-emph');
  }

  /* ---- open and close ---- */

  function open(from) {
    if (dlg.open) return;
    opener = from || document.activeElement;
    mode = desk.matches ? 'drop' : 'sheet';
    restore = true;
    closing = false;
    clearTimeout(closeTimer);
    dlg.classList.remove('is-closing');
    dlg.classList.toggle('is-drop', mode === 'drop');

    if (mode === 'drop') {
      emphasise();
      dlg.show();
      place();
    } else {
      unplace();
      html.classList.add('instyle-catalogue-open');
      dlg.showModal();
    }
    expand(opener, true);

    // Start at the close button of whichever layout is showing.
    var close = Array.prototype.filter.call(dlg.querySelectorAll('[data-instyle-catalogue-close]'), visible)[0];
    if (close) close.focus({ preventScroll: true });

    // Phone: open at the top, then bring the category you are on into view
    // if it would sit low in the sheet.
    var body = dlg.querySelector('.instyle-catalogue__body');
    if (body) body.scrollTop = 0;
    var here = body && visible(body) && body.querySelector('[aria-current="page"]');
    if (here) {
      var top = here.getBoundingClientRect().top - body.getBoundingClientRect().top;
      if (top > body.clientHeight * 0.6) body.scrollTop = top - body.clientHeight * 0.3;
    }
  }

  function finish() {
    clearTimeout(closeTimer);
    dlg.removeEventListener('animationend', onEnd);
    dlg.classList.remove('is-closing');
    if (dlg.open) {
      dlg.close();
      // The `close` event arrives a task later, possibly after the next
      // open() (the other button, or crossing 990px): tidy up now, and let
      // that event know it has nothing left to do.
      handled++;
      cleanup();
    }
  }

  function onEnd(e) {
    if (e.target === dlg && /-out$/.test(e.animationName || '')) finish();
  }

  function shut(keepFocus) {
    if (!dlg.open || closing) return;
    if (keepFocus) restore = false;
    if (reduce.matches) {
      finish();
      return;
    }
    closing = true;
    dlg.addEventListener('animationend', onEnd);
    dlg.classList.add('is-closing');
    closeTimer = setTimeout(finish, 450);
  }

  function cleanup() {
    closing = false;
    clearTimeout(closeTimer);
    dlg.classList.remove('is-closing');
    html.classList.remove('instyle-catalogue-open');
    var back = opener;
    opener = null;
    mode = null;
    expand(back, false);
    // After a click elsewhere, focus goes back too, unless that click put it
    // on something the visitor can use (a link, a field): never steal that.
    var now = document.activeElement;
    var taken =
      now &&
      now !== document.body &&
      !dlg.contains(now) &&
      now.matches('a[href], button, input, select, textarea, [contenteditable], [tabindex]:not([tabindex="-1"])');
    if ((restore || !taken) && back && document.contains(back) && typeof back.focus === 'function') {
      back.focus({ preventScroll: true });
    }
  }

  // A close finish() did not do (Esc when the browser does not let `cancel`
  // be held back) still ends in cleanup().
  dlg.addEventListener('close', function () {
    if (handled > 0) {
      handled--;
      return;
    }
    cleanup();
  });

  // Esc on the phone sheet (a modal): play the closing animation instead of
  // vanishing.
  dlg.addEventListener('cancel', function (e) {
    e.preventDefault();
    shut();
  });

  // Esc on the computer dropdown: a non-modal dialog gets no `cancel`.
  document.addEventListener('keydown', function (e) {
    if (mode !== 'drop' || !dlg.open || e.key !== 'Escape') return;
    e.preventDefault();
    shut();
  });

  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-instyle-catalogue-close]')) {
      shut();
      return;
    }
    // Phone sheet: a click on the dialog element itself is a click on the
    // backdrop, since every pixel inside it belongs to a child.
    if (mode === 'sheet' && e.target === dlg) shut();
  });

  // Computer dropdown: a press anywhere outside it, other than its own
  // button (which toggles it, below), closes it and leaves focus where the
  // visitor put it.
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (mode !== 'drop' || !dlg.open) return;
      if (dlg.contains(e.target)) return;
      if (opener && opener.contains(e.target)) return;
      shut(true);
    },
    true
  );

  // Computer dropdown: tabbing out of it closes it.
  dlg.addEventListener('focusout', function (e) {
    if (mode !== 'drop' || !dlg.open) return;
    var to = e.relatedTarget;
    if (!to || dlg.contains(to)) return;
    shut(true);
  });

  // Phone sheet: Tab wraps inside it.
  dlg.addEventListener('keydown', function (e) {
    if (mode !== 'sheet' || e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dlg.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (!dlg.open) return;
    // Crossing 990px changes what the catalogue is; close rather than morph.
    if ((mode === 'drop') !== desk.matches) finish();
    else place();
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-instyle-catalogue-open]');
    if (!t) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    // Computer, 2026-10-03: the menu bar's own catalogue panel, pinned open
    // under the menu bar (snippets/instyle-mega-menu.liquid), instead of the
    // dropdown under the button. Naman: the dropdown "just doesn't look good
    // appearing in the middle of the page"; the menu bar's panel "appears in
    // the correct way". The dropdown below stays as the fallback for a header
    // without that panel. e.detail is 0 for a keyboard press.
    if (desk.matches && window.InStyleMega && typeof window.InStyleMega.pin === 'function') {
      if (dlg.open) finish();
      window.InStyleMega.pin(t, e.detail === 0);
      return;
    }
    // The same button again closes it (the computer dropdown is a toggle).
    if (dlg.open && t === opener) {
      shut();
      return;
    }
    if (dlg.open) finish();
    open(t);
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-instyle-catalogue-open]'), function (el) {
    expand(el, false);
  });
})();
